import React from 'react';
import Wrapper from './styles';
import { translate } from '../../../services/translate';
import { getRoute, isActiveRoute } from '../../../services/router';
import UiNavLink from '../../ui/nav-link/UiNavLink';
import { useStore } from '../../../hooks/useStore';
import { stores } from '../../../stores';
import ReferAFriendBannerMessageProgress from './progress/ReferAFriendBannerMessageProgress';
import { useReferAFriend } from '../../../hooks/useReferAFriend';

export default function ReferAFriendBannerMessage() {
    const isCasinoView = isActiveRoute(getRoute('casino-game'), false);
    const [user] = useStore(stores.user);

    const { rafBannerMessage } = useReferAFriend(user?.id);

    if (isCasinoView || !rafBannerMessage) {
        return null;
    }

    return (
        <Wrapper>
            <div className="raf-banner-message-container">
                <p>
                    {translate(
                        `${rafBannerMessage.time_to_expire.days > 0 ? 'days' : 'hours'}-${rafBannerMessage.status}`,
                        'ui.raf.banner.message',
                        {
                            days: rafBannerMessage.time_to_expire.days,
                            hours: rafBannerMessage.time_to_expire.hours,
                        },
                    )}

                    {rafBannerMessage.status === 'registered' && (
                        <UiNavLink to={`${getRoute('deposit')}`} className="link-to-deposit">
                            {translate('click-to-deposit', 'ui.raf.banner.message')}
                        </UiNavLink>
                    )}
                </p>
                {rafBannerMessage.lock_id && <ReferAFriendBannerMessageProgress rafBannerMessage={rafBannerMessage} />}
            </div>
        </Wrapper>
    );
}
